import * as types from '../mutation-types';

const registerStore = {
  state: {
    name: '',
    phone: '',
    password: '',
    orgId: '',
    orgName: ''
  },
  getters: {
    name: state => state.name,
    phone: state => state.phone,
    password: state => state.password,
    orgId: state => state.orgId,
    orgName: state => state.orgName
  },
  mutations: {
    [types.SET_NAME](state, data) {
      state.name = data;
    },
    [types.SET_PHONE](state, data) {
      state.phone = data;
    },
    [types.SET_PASSWORD](state, data) {
      state.password = data;
    },
    [types.SET_ORGID](state, data) {
      state.orgId = data;
    },
    [types.SET_ORGNAME](state, data) {
      state.orgName = data;
    }
  },
  actions: {}
};

export default registerStore;
